import styled from '@emotion/styled'

import { typo } from '~/@common/styles'

export const S = {
  Content: styled.div`
    flex: 1;
    padding: 24px 16px 40px;
    overflow: auto;
  `,

  Date: styled.p`
    ${typo.body02}
    color: var(--Colors-Gray-700);

    margin-bottom: 14px;
  `,

  Title: styled.p`
    ${typo.body01}
    font-weight: 700;
    color: var(--Colors-Gray-900);

    margin-bottom: 10px;
  `,

  Body: styled.p`
    ${typo.body02}
    color: var(--Colors-Gray-900);

    white-space: pre-wrap;
    word-break: break-word;
  `,

  Empty: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 80px 0;
    ${typo.body02}
    color: var(--Colors-Gray-500);
  `,
}
